module.exports = __webpack_public_path__ + "img/16.89fdbf9b.png";